
// ============================================================================
// 1. Bond Tent / Rising Equity Glidepath
// ============================================================================

export function calculateGlidepath({
  startStockPct = 0.30,
  endStockPct = 0.70,
  glidepathYears = 15,
  currentYear = 0,
}) {
  if (currentYear >= glidepathYears) return endStockPct;
  const progress = currentYear / glidepathYears;
  return startStockPct + (endStockPct - startStockPct) * progress;
}
